import { Table } from "antd";
import React, { useState } from "react";
import { formatNumber, showError } from "../../../../../utils/utilities";
import { useDispatch, useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import CostEstimation from "../../../../../services/api/CostEstimation";
import { setLoading } from "../../../../../redux/ducks/Loading";
import { get } from "lodash";
import KickOff from "../../../../../services/api/KickOff";

const SummaryTable = (props) => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const filters = useSelector((state) => state.FiltersDuck.filters);
  const currentLanguage = useSelector((state) => get(state.languageDuck, "currentLanguage", "GB"));
  const [state, setState] = useState({
    expandedRowKeysWP: [],
    wpContentExpanded: [],
  });

  const columns = [
    {
      title: t("projectEstimate.detail.tabs.costEstimation.table.activityResource"),
      dataIndex: "activity",
      width: 200,
      fixed: "left",
    },
    {
      title: t("projectEstimate.detail.tabs.costEstimation.table.ap"),
      dataIndex: ["amountValues", "columnValueMap", "AP"],
      width: 100,
      fixed: "left",
      className: "table-value-right highlighted",
      render: (amount) => formatNumber({ value: amount, suffix: "EUR", lang: currentLanguage, decimalScale: 0 }),
    },
    {
      title: t("projectEstimate.detail.tabs.costEstimation.table.gen"),
      dataIndex: ["amountValues", "columnValueMap", "JANUARY"],
      width: 100,
      className: "table-value-right",
      render: (amount) => formatNumber({ value: amount, suffix: "EUR", lang: currentLanguage, decimalScale: 0 }),
    },
    {
      title: t("projectEstimate.detail.tabs.costEstimation.table.feb"),
      dataIndex: ["amountValues", "columnValueMap", "FEBRUARY"],
      width: 100,
      className: "table-value-right",
      render: (amount) => formatNumber({ value: amount, suffix: "EUR", lang: currentLanguage, decimalScale: 0 }),
    },
    {
      title: t("projectEstimate.detail.tabs.costEstimation.table.mar"),
      dataIndex: ["amountValues", "columnValueMap", "MARCH"],
      width: 100,
      className: "table-value-right",
      render: (amount) => formatNumber({ value: amount, suffix: "EUR", lang: currentLanguage, decimalScale: 0 }),
    },
    {
      title: t("projectEstimate.detail.tabs.costEstimation.table.apr"),
      dataIndex: ["amountValues", "columnValueMap", "APRIL"],
      width: 100,
      className: "table-value-right",
      render: (amount) => formatNumber({ value: amount, suffix: "EUR", lang: currentLanguage, decimalScale: 0 }),
    },
    {
      title: t("projectEstimate.detail.tabs.costEstimation.table.may"),
      dataIndex: ["amountValues", "columnValueMap", "MAY"],
      width: 100,
      className: "table-value-right",
      render: (amount) => formatNumber({ value: amount, suffix: "EUR", lang: currentLanguage, decimalScale: 0 }),
    },
    {
      title: t("projectEstimate.detail.tabs.costEstimation.table.jun"),
      dataIndex: ["amountValues", "columnValueMap", "JUNE"],
      width: 100,
      className: "table-value-right",
      render: (amount) => formatNumber({ value: amount, suffix: "EUR", lang: currentLanguage, decimalScale: 0 }),
    },
    {
      title: t("projectEstimate.detail.tabs.costEstimation.table.jul"),
      dataIndex: ["amountValues", "columnValueMap", "JULY"],
      width: 100,
      className: "table-value-right",
      render: (amount) => formatNumber({ value: amount, suffix: "EUR", lang: currentLanguage, decimalScale: 0 }),
    },
    {
      title: t("projectEstimate.detail.tabs.costEstimation.table.aug"),
      dataIndex: ["amountValues", "columnValueMap", "AUGUST"],
      width: 100,
      className: "table-value-right",
      render: (amount) => formatNumber({ value: amount, suffix: "EUR", lang: currentLanguage, decimalScale: 0 }),
    },
    {
      title: t("projectEstimate.detail.tabs.costEstimation.table.sep"),
      dataIndex: ["amountValues", "columnValueMap", "SEPTEMBER"],
      width: 100,
      className: "table-value-right",
      render: (amount) => formatNumber({ value: amount, suffix: "EUR", lang: currentLanguage, decimalScale: 0 }),
    },
    {
      title: t("projectEstimate.detail.tabs.costEstimation.table.oct"),
      dataIndex: ["amountValues", "columnValueMap", "OCTOBER"],
      width: 100,
      className: "table-value-right",
      render: (amount) => formatNumber({ value: amount, suffix: "EUR", lang: currentLanguage, decimalScale: 0 }),
    },
    {
      title: t("projectEstimate.detail.tabs.costEstimation.table.nov"),
      dataIndex: ["amountValues", "columnValueMap", "NOVEMBER"],
      width: 100,
      className: "table-value-right",
      render: (amount) => formatNumber({ value: amount, suffix: "EUR", lang: currentLanguage, decimalScale: 0 }),
    },
    {
      title: t("projectEstimate.detail.tabs.costEstimation.table.dec"),
      dataIndex: ["amountValues", "columnValueMap", "DECEMBER"],
      width: 100,
      className: "table-value-right",
      render: (amount) => formatNumber({ value: amount, suffix: "EUR", lang: currentLanguage, decimalScale: 0 }),
    },
    {
      title: t("projectEstimate.detail.tabs.costEstimation.table.as"),
      dataIndex: ["amountValues", "columnValueMap", "AS"],
      fixed: "right",
      width: 100,
      className: "table-value-right highlighted",
      render: (amount) => formatNumber({ value: amount, suffix: "EUR", lang: currentLanguage, decimalScale: 0 }),
    },
    {
      title: t("projectEstimate.detail.tabs.costEstimation.table.tot"),
      dataIndex: ["amountValues", "columnValueMap", "TOT"],
      fixed: "right",
      width: 100,
      className: "table-value-right highlighted",
      render: (amount) => formatNumber({ value: amount, suffix: "EUR", lang: currentLanguage, decimalScale: 0 }),
    },
  ];

  const expandedRowRender = () => {
    const columns = [
      {
        title: t("projectEstimate.detail.tabs.costEstimation.table.activityResource"),
        dataIndex: "activity",
        width: 200 + 8, // +8 to compensate the negative margin used by antd for expanded rows
        fixed: "left",
        render: (activity) => {
          let activityTitle = activity;
          if (activity === "work") {
            activityTitle = t("projectEstimate.detail.tabs.costEstimation.table.work");
          } else if (activity === "costs") {
            activityTitle = t("projectEstimate.detail.tabs.costEstimation.table.costs");
          }
          return activityTitle;
        },
      },
      {
        title: t("projectEstimate.detail.tabs.costEstimation.table.ap"),
        dataIndex: "AP",
        width: 100,
        fixed: "left",
        className: "table-value-right highlighted",
        render: (amount, record) =>
          formatNumber({
            value: amount,
            suffix: record.isHour ? "HOUR" : "EUR",
            lang: currentLanguage,
            decimalScale: 0,
          }),
      },
      {
        title: t("projectEstimate.detail.tabs.costEstimation.table.gen"),
        dataIndex: "JANUARY",
        width: 100,
        className: "table-value-right",
        render: (amount, record) =>
          formatNumber({
            value: amount,
            suffix: record.isHour ? "HOUR" : "EUR",
            lang: currentLanguage,
            decimalScale: 0,
          }),
      },
      {
        title: t("projectEstimate.detail.tabs.costEstimation.table.feb"),
        dataIndex: "FEBRUARY",
        width: 100,
        className: "table-value-right",
        render: (amount, record) =>
          formatNumber({
            value: amount,
            suffix: record.isHour ? "HOUR" : "EUR",
            lang: currentLanguage,
            decimalScale: 0,
          }),
      },
      {
        title: t("projectEstimate.detail.tabs.costEstimation.table.mar"),
        dataIndex: "MARCH",
        width: 100,
        className: "table-value-right",
        render: (amount, record) =>
          formatNumber({
            value: amount,
            suffix: record.isHour ? "HOUR" : "EUR",
            lang: currentLanguage,
            decimalScale: 0,
          }),
      },
      {
        title: t("projectEstimate.detail.tabs.costEstimation.table.apr"),
        dataIndex: "APRIL",
        width: 100,
        className: "table-value-right",
        render: (amount, record) =>
          formatNumber({
            value: amount,
            suffix: record.isHour ? "HOUR" : "EUR",
            lang: currentLanguage,
            decimalScale: 0,
          }),
      },
      {
        title: t("projectEstimate.detail.tabs.costEstimation.table.may"),
        dataIndex: "MAY",
        width: 100,
        className: "table-value-right",
        render: (amount, record) =>
          formatNumber({
            value: amount,
            suffix: record.isHour ? "HOUR" : "EUR",
            lang: currentLanguage,
            decimalScale: 0,
          }),
      },
      {
        title: t("projectEstimate.detail.tabs.costEstimation.table.jun"),
        dataIndex: "JUNE",
        width: 100,
        className: "table-value-right",
        render: (amount, record) =>
          formatNumber({
            value: amount,
            suffix: record.isHour ? "HOUR" : "EUR",
            lang: currentLanguage,
            decimalScale: 0,
          }),
      },
      {
        title: t("projectEstimate.detail.tabs.costEstimation.table.jul"),
        dataIndex: "JULY",
        width: 100,
        className: "table-value-right",
        render: (amount, record) =>
          formatNumber({
            value: amount,
            suffix: record.isHour ? "HOUR" : "EUR",
            lang: currentLanguage,
            decimalScale: 0,
          }),
      },
      {
        title: t("projectEstimate.detail.tabs.costEstimation.table.aug"),
        dataIndex: "AUGUST",
        width: 100,
        className: "table-value-right",
        render: (amount, record) =>
          formatNumber({
            value: amount,
            suffix: record.isHour ? "HOUR" : "EUR",
            lang: currentLanguage,
            decimalScale: 0,
          }),
      },
      {
        title: t("projectEstimate.detail.tabs.costEstimation.table.sep"),
        dataIndex: "SEPTEMBER",
        width: 100,
        className: "table-value-right",
        render: (amount, record) =>
          formatNumber({
            value: amount,
            suffix: record.isHour ? "HOUR" : "EUR",
            lang: currentLanguage,
            decimalScale: 0,
          }),
      },
      {
        title: t("projectEstimate.detail.tabs.costEstimation.table.oct"),
        dataIndex: "OCTOBER",
        width: 100,
        className: "table-value-right",
        render: (amount, record) =>
          formatNumber({
            value: amount,
            suffix: record.isHour ? "HOUR" : "EUR",
            lang: currentLanguage,
            decimalScale: 0,
          }),
      },
      {
        title: t("projectEstimate.detail.tabs.costEstimation.table.nov"),
        dataIndex: "NOVEMBER",
        width: 100,
        className: "table-value-right",
        render: (amount, record) =>
          formatNumber({
            value: amount,
            suffix: record.isHour ? "HOUR" : "EUR",
            lang: currentLanguage,
            decimalScale: 0,
          }),
      },
      {
        title: t("projectEstimate.detail.tabs.costEstimation.table.dec"),
        dataIndex: "DECEMBER",
        width: 100,
        className: "table-value-right",
        render: (amount, record) =>
          formatNumber({
            value: amount,
            suffix: record.isHour ? "HOUR" : "EUR",
            lang: currentLanguage,
            decimalScale: 0,
          }),
      },
      {
        title: t("projectEstimate.detail.tabs.costEstimation.table.as"),
        dataIndex: "AS",
        fixed: "right",
        width: 100,
        className: "table-value-right highlighted",
        render: (amount, record) =>
          formatNumber({
            value: amount,
            suffix: record.isHour ? "HOUR" : "EUR",
            lang: currentLanguage,
            decimalScale: 0,
          }),
      },
      {
        title: t("projectEstimate.detail.tabs.costEstimation.table.tot"),
        dataIndex: "TOT",
        fixed: "right",
        width: 100,
        className: "table-value-right highlighted",
        render: (amount, record) =>
          formatNumber({
            value: amount,
            suffix: record.isHour ? "HOUR" : "EUR",
            lang: currentLanguage,
            decimalScale: 0,
          }),
      },
    ];

    return (
      <Table
        bordered
        dataSource={state.wpContentExpanded}
        columns={columns}
        size="small"
        pagination={false}
        scroll={{ x: 1500 }}
        className="fitExpandedRowInTableWidth"
      />
    );
  };

  const getExpandedRowDataWp = async (expanded, record) => {
    dispatch(setLoading(true));
    const expandedKeys = [];
    let contentExpanded = [];
    if (expanded) {
      let wbs = null;
      if (props.whereIam === "costEstimation") {
        wbs =
          props.isWip === true
            ? await CostEstimation.projectEstimateWorkPackageTableSummaryWipWbs(
                props.id,
                record.wbsId,
                filters.obj.year
              )
            : await CostEstimation.projectEstimateWorkPackageTableSummaryWbs(props.id, record.wbsId, filters.obj.year);
      } else {
        wbs =
          props.isWip === true
            ? await KickOff.projectEstimateKickOffSummaryWipWbs(props.id, record.wbsId, filters.obj.year)
            : await KickOff.projectEstimateKickOffSummaryWbs(props.id, record.wbsId, filters.obj.year);
      }
      if (!wbs.error) {
        expandedKeys.push(record.key);
        if (wbs.data && wbs.data.totalQuantityValues && wbs.data.totalQuantityValues.columnValueMap) {
          const totalQuantityValues = wbs.data.totalQuantityValues.columnValueMap;
          totalQuantityValues.activity = "work";
          totalQuantityValues.key = "work";
          totalQuantityValues.isHour = true;
          totalQuantityValues.children = [];
          if (wbs.data.costEstimationKickoffValueView) {
            wbs.data.costEstimationKickoffValueView.forEach((cv, i) => {
              if (cv.quantityValues && cv.quantityValues.columnValueMap && cv.serviceType === "HOUR") {
                const childrenValues = cv.quantityValues.columnValueMap;
                childrenValues.activity = cv.activity;
                childrenValues.key = `work-${i}`;
                childrenValues.isHour = true;
                totalQuantityValues.children.push(childrenValues);
              }
            });
          }
          contentExpanded.push(totalQuantityValues);
        }
        if (wbs.data && wbs.data.totalAmountValues && wbs.data.totalAmountValues.columnValueMap) {
          const totalAmountValues = wbs.data.totalAmountValues.columnValueMap;
          totalAmountValues.activity = "costs";
          totalAmountValues.key = "costs";
          totalAmountValues.children = [];
          if (wbs.data.costEstimationKickoffValueView) {
            wbs.data.costEstimationKickoffValueView.forEach((cv, i) => {
              if (cv.amountValues && cv.amountValues.columnValueMap) {
                const childrenValues = cv.amountValues.columnValueMap;
                childrenValues.activity = cv.activity;
                childrenValues.key = `costs-${i}`;
                totalAmountValues.children.push(childrenValues);
              }
            });
          }
          contentExpanded.push(totalAmountValues);
        }
      } else {
        showError(get(wbs, "error.messageCode", "ER000"));
      }
    }
    setState((prevState) => ({
      ...prevState,
      wpContentExpanded: contentExpanded,
      expandedRowKeysWP: expandedKeys,
    }));
    dispatch(setLoading(false));
  };
  return (
    <Table
      bordered
      dataSource={props.dataContentSummary}
      columns={columns}
      size="small"
      pagination={false}
      scroll={{ x: 1500 }}
      expandable={{
        expandedRowRender,
        expandedRowKeys: state.expandedRowKeysWP,
        onExpand: (expanded, record) => getExpandedRowDataWp(expanded, record),
      }}
      rowClassName="table-secondary"
    />
  );
};

export default SummaryTable;
